import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'cx_foundations-ticketcreated-action_unknown';

/**
 * When the Zendesk ticket created, we need to record ticketId, brand order,Token, and user token
 */
export function trackCxFoundationsTicketcreated(
  ticketId: string,
  brandOrderToken: string,
  userToken2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { ticketId, brandOrderToken, userToken2 },
  });
}
